var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPwdCheckCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 0C3.13307 0 0 3.13307 0 7C0 10.8669 3.13307 14 7 14C10.8669 14 14 10.8669 14 7C14 3.13307 10.8669 0 7 0ZM10.4323 8.8375C10.5649 8.97015 10.5649 9.1847 10.4323 9.31735L9.31449 10.4323C9.18184 10.5649 8.96735 10.5649 8.8347 10.4323L7 8.58066L5.1625 10.4323C5.02984 10.5649 4.81532 10.5649 4.68266 10.4323L3.56774 9.31449C3.43508 9.18184 3.43508 8.96735 3.56774 8.8347L5.41935 7L3.56774 5.1625C3.43508 5.02984 3.43508 4.81532 3.56774 4.68266L4.68548 3.56492C4.81815 3.43226 5.03266 3.43226 5.16532 3.56492L7 5.41935L8.8375 3.56774C8.97015 3.43508 9.1847 3.43508 9.31735 3.56774L10.4351 4.68548C10.5677 4.81815 10.5677 5.03266 10.4351 5.16532L8.58066 7L10.4323 8.8375Z",
    fill: "#E74C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwdCheckCross);
export default __webpack_public_path__ + "static/media/pwd-check-cross.970fe45fbb93c1bb141d3b4e03f5f9c7.svg";
export { ForwardRef as ReactComponent };